import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SupportService {

  constructor(private http: HttpClient) {}

  send(body): Observable<any> {
    return this.http.post<any>(`${environment.apis.lineupUrl}support/v1/new-ticket`, body);
  }

  
}